module.exports = __webpack_public_path__ + "static/media/pasteque.a6a970d6.svg";